import { createContext } from "react";

export const ScreenSizeContext = createContext();